/**
 * AG Grid Enterprise Module Registration
 *
 * Registers all required AG Grid Enterprise modules for pivot table functionality.
 * This file should be imported once at application startup (in App.tsx).
 *
 * For AG Grid 34+, IntegratedChartsModule requires ag-charts-enterprise.
 * See: https://www.ag-grid.com/react-data-grid/integrated-charts-installation/
 */
// eslint-disable-next-line import/no-extraneous-dependencies
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  CellSelectionModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  ExcelExportModule,
  FiltersToolPanelModule,
  IntegratedChartsModule,
  MenuModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
} from 'ag-grid-enterprise';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';

// Register all required modules
// IntegratedChartsModule.with() is required in AG Grid 34+ to enable charts
ModuleRegistry.registerModules([
  AllCommunityModule,
  CellSelectionModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  ExcelExportModule,
  FiltersToolPanelModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
  MenuModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
]);
